import { Cryptide } from "@tideorg/js";

const Ed25519Scheme = Cryptide.Components.Schemes.Ed25519.Ed25519Scheme;
const TideKey = Cryptide.TideKey;

export function createNewTideKey() {
  return TideKey.NewKey(Ed25519Scheme).get_private_component().Serialize().ToString();
}

export function createTideKeyFromSerializedComponent(component) {
  return TideKey.FromSerializedComponent(component);
}
